import { mapState } from 'vuex'
import { existHierarchy, notification } from '../plugins/helpers'
import { OpcoesFuroDesc, SituacaoGrupo } from '../plugins/constants'
export default {
  computed: {
    ...mapState(['hierarquia_comercial']),
    is_usuario_logado_hierarquia () {
      return existHierarchy(this.hierarquia_comercial)
    }
  },
  methods: {
    async validarDadosDaVenda (id_pedido) {
      let clienteValido = true
      let pedidoValido = true
      let erro = false

      await this.$http.get(`/proposta/validar_cliente/${id_pedido}`).then((response) => {
        clienteValido = response.data.venda_ok
        if (!clienteValido) {
          notification('warning', 'Caro parceiro, há informações obstruídas no cadastro de seu cliente. Sugerimos criar uma nova venda para ele, evitando possíveis erros com o cadastro. Caso o problema persista, entre em contato com a Área de Suporte!')
        }
      }).catch((err) => {
        erro = true
        if (err.response.status === 422) {
          notification('error', err, 'Erro ao validar os dados do cliente, por favor tente novamente, caso persistir, entre em contato com a Área de Suporte.')
        } else {
          notification('error', 'Erro ao validar os dados do cliente, por favor tente novamente, caso persistir, entre em contato com a Área de Suporte.')
        }
      })

      await this.$http.get(`/vendas/validar/${id_pedido}`).then((response) => {
        pedidoValido = response.data.success
        if (!pedidoValido) {
          notification('error', 'Caro parceiro, encontramos divergências em sua proposta. Por favor, entre em contato com a Área de Suporte.')
        }
      }).catch((err) => {
        erro = true
        if (err.response && err.response.status === 400) {
          notification('error', 'Caro parceiro, encontramos divergências em sua proposta. Por favor, entre em contato com a Área de Suporte.')
        } else {
          notification('error', 'Erro ao validar os dados do pedido, por favor tente novamente, caso persistir, entre em contato com a Área de Suporte.')
        }
      })

      if (erro || !clienteValido || !pedidoValido) {
        return false
      }

      return true
    },
    getOpcaoFuro (opcao_furo, situacao_grupo) {
      if (situacao_grupo !== SituacaoGrupo.Formacao) {
        return OpcoesFuroDesc[opcao_furo] || 'Não há.'
      }
      return 'Não há.'
    },
    getParcelasFuro (qt_parcelas_furo, situacao_grupo) {
      if (situacao_grupo !== SituacaoGrupo.Formacao) {
        return qt_parcelas_furo || 'Não há.'
      }
      return '-'
    }
  }
}
